import React from 'react';
export function Footer() {
  return <footer className="bg-gray-50 border-t border-border-gray py-4 px-6" data-id="element-33">
      <p className="text-xs text-text-secondary text-center leading-relaxed" data-id="element-34">
        For Healthcare Professionals only. [Ref: Product Information]
      </p>
    </footer>;
}